<template lang="pug">
div(
  v-if="getActiveCard"
  style="height:100%"
)
  div(
    :style="styles.topBar"
  )
    button.button__action(
      @click="goBack"
    )
      ChevronLeftIcon(
        class="icon"
      )
      | Back
    .submit__container
      button.button__action.button__delete(
          @click="deleteCard()"
      ) {{getActiveCard.deleted ? 'Restore Card' : 'Delete Card'}}
      div.alerts
        span(
          v-if="getActiveCard.localRecords.length > 1"
        ) Switching locales will clear unsaved changes.
        span(
          v-if="isDraft"
        ) You are viewing a draft card. Click Publish to make this draft go live.
      div.locales
        multiselect.locale-picker(
            v-model="getActiveLocale"
            :options="getSortedAvailableLocales"
            :searchable="false"
            :selectLabel="''"
            :allow-empty="false"
            :deselectLabel="''"
            :multiple="false"
        )
      button.button__action(
        @click="toggleAddLocale"
      ) Add Locale
      button.button__submit(
        type="button"
        :class="unsavedChanges ? 'active' : 'disabled'"
        @click="saveChanges"
      ) Save Changes
      button.button__submit(
        type="button"
        :class="(!unsavedChanges && isDraft) ? 'active' : 'disabled'"
        @click="publishChanges"
      ) Publish Card
  div
  .container
    .editing__container
      .card__title-wrapper
        .card__titles
          h4 {{getActiveCard.legacyName}}
          h1 {{getActiveCard.displayName}}
          p Last updated:
            span  {{moment(getActiveCard.updatedAt)}}
          p(
            v-if="getActiveCard.cardType"
          ) Card Type:
            span  {{getActiveCard.cardType.name || ''}}
        .card-markets
          h3 Markets
          multiselect(
            v-model="getSortedAvailableLocales"
            :options="getMarketsByLocale"
            placeholder="Add a Market"

            :multiple="true"
          )
        .card-message(
          v-if="getAvailableFields.indexOf('message') > -1"
        )
          h3 Message
          section.messages
            label(
              for="subject"
            ) Subject
            MixedContentInput(
              :template="shortId"
              :isEditing="true"
              section="subject"
              :paramOptions="getActiveCard.cardType.parameters"
              :edit="checkEdits"
            )
            label(
              for="body"
            ) Body Message
            MixedContentInput(
              :template="shortId"
              :isEditing="true"
              section="bodyText"
              :paramOptions="getActiveCard.cardType.parameters"
              :edit="checkEdits"
            )
            div(
                v-if="getActiveLocale !== 'EN-US' && getEnglishRecords"
            )
                h3 English Reference
                p
                    strong Subject:
                    | &nbsp; {{ getEnglishRecords.message ? getEnglishRecords.message.subject : '(no content)' }}
                p
                    strong Body Text:
                    | &nbsp; {{ getEnglishRecords.message ? getEnglishRecords.message.bodyText : '(no content)' }}
        .card-reason(
            v-if="getAvailableFields.includes('reason')"
        )
            h3 Reason
            section.reason
            MixedContentInput(
                :template="shortId"
                :isEditing="true"
                section="reason"
                :paramOptions="getActiveCard.cardType.parameters"
                :edit="checkEdits"
            )
            div(
                v-if="getActiveLocale !== 'EN-US' && getEnglishRecords"
            )
                h3 English Reference
                p
                    strong Reason:
                    | &nbsp; {{ getEnglishRecords.reason ? getEnglishRecords.reason : '(no content)' }}

      .template__card-wrapper
        .action-card
          button.button__action.copy-button(
            @click="toggleCopyContent"
          ) Copy Content From Another Market
          div
            h3 Action Card
          .options(
            v-if="getAvailableFields.includes('title') || getAvailableFields.includes('callToAction')"
          )
            label Card State:
            .button-group
              button.button__action(
                :key="`setting-${setting}`"
                @click="setActiveSetting(setting)"
                :class="setting == activeSetting ? 'active' : ''"
                v-for="setting in settings"
              ) {{setting}}
          div.action-card__container
            ActionCard.action-card(
              :activeSetting="activeSetting"
              :body="body"
              :callToAction="callToAction"
              :checkEdits="checkEdits"
              :helpText="helpText"
              :helpUrl="helpUrl"
              :displayName="displayName"
              :isEditing="true"
              :media="getActiveMedia"
              :subject="subject"
              :title="title"
              :params="getActiveCard.cardType.parameters"
              :fields="getAvailableFields"
            )
            .action-card-english(
              v-if="getActiveLocale !== 'EN-US' && getEnglishRecords"
            )
              h3 English Reference
              .title(
                v-if="getAvailableFields.indexOf('title') > -1"
              ) {{ getEnglishRecords.title ? getEnglishRecords.title[activeSetting] : '(no content)' }}
              .description(
                v-if="getAvailableFields.indexOf('callToAction') > -1"
              ) {{ getEnglishRecords.callToAction ? getEnglishRecords.callToAction[activeSetting] : '(no content)'}}
              .action-button(
                  v-if="fields.includes('buttonText')"
              ) {{ getEnglishRecords.actionButton ? getEnglishRecords.actionButton[activeSetting] : '(no content)'}}

              .help(
                v-if="getAvailableFields.indexOf('help') > -1"
              ) {{ getEnglishRecords.help ? getEnglishRecords.help.text : ''}}
</template>

<script>
import store from '../../store';
import Spinner from '../general/Spinner';
import ActionCard from '../general/ActionCard';
import Services from '../../services/Services';
import MixedContentInput from '../general/MixedContentInput';
import { postResource } from '../../services/Utils';
import VueNotifications from 'vue-notifications';
import MediaCard from '../general/MediaCard';
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft';
import PlusIcon from 'vue-material-design-icons/Plus';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import moment from 'moment';
export default {
  name: 'cardTemplate',
  components: {
    ActionCard,
    ChevronLeftIcon,
    MediaCard,
    MixedContentInput,
    Multiselect,
    PlusIcon,
    Spinner
  },
  computed: {
    getActiveMedia: {
      get: function() {
        return store.getters.getActiveMedia;
      },
      set: function(newMedia) {
        store.commit('setActiveMedia', newMedia);
        if (this.getActiveLocale === this.getActiveCard.fallbackLocale) {
          // edit on the card level as well
          let activeCard = { ...this.getActiveCard };
          activeCard.mediaID = newMedia;
          store.commit('setActiveCard', activeCard);
        }
        let activeRecord = { ...this.getActiveLocalRecord };
        activeRecord.mediaId = newMedia;
        store.commit('setActiveLocalRecord', activeRecord);
      }
    },
    getActiveCard() {
      return store.getters.getActiveCard;
    },
    getAvailableFields() {
      if (this.getActiveCard) {
        return this.getActiveCard.cardType.fields;
      }
    },
    getEnglishRecords() {
      if (this.getActiveCard) {
        if (this.getActiveCard.localRecords.length > 1) {
          const filteredRecords = this.getActiveCard.localRecords.filter(
            record => {
              return record.locale === 'EN-US';
            }
          );
          if (filteredRecords && filteredRecords.length) {
            return filteredRecords[0].content;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    getSortedAvailableLocales: {
      get: function() {
        if (this.getActiveCard && this.getActiveCard.localRecords) {
          let locales = [];

          this.getActiveCard.localRecords.forEach(locale => {
            // lol?
            locales.push(locale.locale);
          });

          return locales.sort((a, b) => a.name - b.name).reverse();
        }
      },
      set: function(newLocales) {
        let activeCard = { ...this.getActiveCard };
        activeCard.markets = newLocales;
        store.commit('setActiveCard', activeCard);
        if (newLocales.length > this.getActiveCard.localRecords.length) {
          store.commit('showCreateLocalRecordModal', true);
        }
      }
    },
    getMarketsByLocale() {
      if (this.markets) {
        let marketsByLocale = [];

        this.markets.forEach(market => {
          marketsByLocale.push(market.locale);
        });

        return marketsByLocale;
      }
    },
    getActiveLocale: {
        get() {
            return store.getters.getActiveLocale;
        },
        set(locale) {
            this.changeLocale(locale);
        }
    },
    getActiveLocalRecord() {
      return store.getters.getActiveLocalRecord;
    },
    getActiveLocalRecordSaved() {
      return store.getters.getActiveLocalRecordSaved;
    }
  },
  watch: {
    getActiveLocalRecord(data, old) {
      console.log(data)
      this.checkUnsavedChanges(data);
    }
  },
  data() {
    return {
      activeSetting: 'initial',
      defaultLocale: null,
      settings: ['initial', 'intermediate', 'done', 'completed'],
      ready: false,
      showFooterPopup: false,
      helpText: null,
      helpTextSaved: null,
      helpUrl: null,
      helpUrlSaved: null,
      displayName: null,
      title: null,
      titleSaved: null,
      callToAction: null,
      callToActionSaved: null,
      subject: null,
      subjectSaved: null,
      body: null,
      bodySaved: null,
      label: null,
      labelSaved: null,
      socialLinks: null,
      socialLinksSaved: null,
      icon: null,
      iconSaved: null,
      reason: null,
      buttonText: null,
      buttonTextSaved: null,
      actionUrl: null,
      actionUrlSaved: null,
      triggerContextImage: null,
      triggerContextImageSaved: null,
      shortId: this.$route.params.shortId,
      params: [],
      fields: [],
      unsavedChanges: false,
      isDraft: false,
      unsavedEdits: {
        callToAction: false,
        helpText: false,
        helpUrl: false,
        title: false,
        subject: false,
        body: false
      },
      market: null,
      markets: store.getters.getMarkets,
      editHint: true,
      saveText: 'Save',
      toggleAddMediaToCardModal: Services.toggleAddMediaToCard,
      styles: {
        backButton: {
          display: 'flex',
          height: '30px',
          justifyContent: 'center',
          alignItems: 'center'
        },
        backArrow: {
          margin: 'auto 5px auto 0'
        },
        pageHeader: {
          display: 'flex',
          padding: '0 2rem',
          width: '100%'
        },
        pageHead: {
          fontSize: '1.5em',
          maxWidth: 600,
          margin: '20px auto 40px',
          fontWeight: 700,
          color: '#aaa'
        },
        messageWrapper: {
          padding: '20px'
        },
        messageContentWrapper: {
          background: '#f5f5f5',
          borderRadius: '10px',
          fontSize: '1.1em',
          padding: '20px'
        },
        mediaButtonContainer: {
          position: 'absolute',
          right: '2rem'
        },
        mediaButtons: {
          background: '#09a3ed',
          fontSize: '0.9em',
          color: '#fff',
          borderRadius: '5px',
          lineHeight: '1.2rem',
          padding: '5px 10px 5px 5px',
          margin: 'auto 0 auto 10px',
          border: '0',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          ':hover': {
            cursor: 'pointer',
            opacity: '0.9'
          }
        },
        titleInputStyle: {
          padding: '10px',
          margin: '0 auto 10px'
        },
        descriptionInputStyle: {
          padding: '10px',
          fontWeight: '400',
          fontSize: '1.5em',
          margin: '0 auto',
          textAlign: 'center'
        },
        subjectInputStyle: {
          padding: '10px',
          fontSize: '1em',
          margin: '0 auto 10px'
        },
        bodyInputStyle: {
          padding: '10px',
          fontSize: '1.25em',
          margin: '0 auto'
        },
        mediaContainer: {
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          height: '100%',
          padding: '1rem 2rem',
          width: '100%'
        },
        cardWrap: {
          display: 'flex',
          flexFlow: 'column nowrap',
          alignItems: 'center'
        },
        card: media => ({
          maxWidth: '500px',
          width: '100%',
          padding: '2rem 1rem',
          minHeight: media ? 'auto' : '600px',
          display: 'flex',
          margin: '0 auto 40px',
          flexFlow: 'column nowrap',
          borderRadius: '3px',
          border: '1px solid #eee'
        }),
        cardHead: {
          fontWeight: '700',
          display: 'flex',
          flexFlow: 'column nowrap',
          alignItems: 'center',
          justifyContent: 'center'
        },
        cardTitle: {
          fontSize: '1.2em',
          color: '#888',
          textAlign: 'center',
          border: '0',
          fontWeight: '400',
          outline: 'none',
          width: '100%',
          margin: 'auto auto 5px'
        },
        cardDescription: {
          fontSize: '1.35em',
          color: '#111',
          textAlign: 'center',
          border: '0',
          fontWeight: '400',
          outline: 'none',
          width: '90%',
          lineHeight: '2px',
          margin: '5px auto auto'
        },
        cardFooter: {
          display: 'flex',
          margin: 'auto 0 0',
          padding: '20px 10px 40px',
          fontSize: '1.1em',
          flexFlow: 'column nowrap',
          alignItems: 'center'
        },
        topBar: {
          boxShadow: '0 0 8px 0 rgba(0,0,0,.1)',
          position: 'relative',
          zIndex: '99',
          boxSizng: 'border-box',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '10px',
          width: '100%'
        },
        editsWrapper: display => ({
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'no-wrap',
          opacity: display ? '1' : '0',
          transition: 'all 0.2s',
          transform: display ? 'translateY(0)' : 'translateY(20px)'
        }),
        editsHint: display => ({
          color: '#AAA',
          fontSize: '1rem',
          position: 'relative',
          opacity: display ? '1' : '0',
          transition: 'all 0.2s'
          // top: '5px'
        }),
        saveButton: {
          background: '#6ab04c',
          fontSize: '1rem',
          color: '#fff',
          borderRadius: '5px',
          padding: '5px 15px',
          margin: 'auto 23px',
          border: '0',
          ':hover': {
            opacity: '0.9'
          }
        },
        footerPopupWrapper: {
          position: 'fixed',
          top: '0',
          zIndex: '999',
          bottom: '0',
          right: '0',
          left: '0',
          background: 'rgba(0,0,0,0.25)',
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        footerPopupModal: {
          width: '400px',
          background: '#fff',
          padding: '10px',
          margin: 'auto',
          display: 'flex',
          flexFlow: 'column nowrap'
        }
      }
    };
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    moment: function(date) {
      return moment(date).fromNow();
    },
    deleteCard() {
        if(this.getActiveCard.deleted) {
             const update = {
                deleted: false,
                _id: this.$route.params.shortId
            }

            postResource(`/v1/actioncards/delete`, false, update)
                .then((res) => {
                    this.getActiveCard.deleted = false;
                    this.showSuccessMsg({
                        message: `${this.getActiveLocale} Action card has been restored!`
                    });
                }).catch((err) => {
                    console.log(err);
                })
        } else {
            store.commit('showDeleteRecordModal', true);
        }
    },
    checkUnsavedChanges(data) {
      const unsavedChanges =
        JSON.stringify(this.getActiveLocalRecord) !==
        JSON.stringify(this.getActiveLocalRecordSaved);
      this.unsavedChanges = unsavedChanges;
      console.log(unsavedChanges);
      return unsavedChanges;
    },
    goBack() {
      this.$router.go(-1);
    },
    publishChanges() {
      const locale = this.getActiveLocale;
      const cardId = this.getActiveCard._id;
      postResource(
        '/v1/actioncards/publish',
        `locale=${locale}&cardId=${cardId}`
      )
        .then((res) => {
          if (res.status === 'success') {
            this.isDraft = false;
            this.showSuccessMsg({
              message: `${this.getActiveLocale} Action card has been published!`
            });
          } else {
            console.log(res);
          }
        })
        .catch(error => console.log(error));
    },
    setActiveSetting(setting) {
      console.log('clicking');
      this.activeSetting = setting;
      // const localContent = this.getActiveCard.localRecords.filter(record => {return record.locale === this.getActiveLocale})[0].content || {};

      // this.title = localContent.title[setting] || '';
      // this.callToAction = localContent.callToAction[setting] || '';
      // // this.market = this.getActiveCard.market;
    },
    toggleFooterPopup() {
      this.showFooterPopup = !this.showFooterPopup;
    },
    toggleAddLocale() {
      store.commit('showCreateLocalRecordModal', true);
    },
    toggleCopyContent(){
        store.commit('showCopyLocalRecordModal', true)
    },
    setActiveMedia(media) {
      store.commit('setActiveMedia', media);
    },
    changeLocale(locale) {
      //   check for changes
      const unsavedChanges =
        JSON.stringify(this.getActiveLocalRecord) !==
        JSON.stringify(this.getActiveLocalRecordSaved);

      let answer = true;

      if (unsavedChanges) {
        answer = window.confirm(
          'You have unsaved changes. Do you want to change locales without saving?'
        );
      }

      if (!unsavedChanges || answer) {
        store.commit('setActiveLocale', locale);
        this.initializeCard(true);
        this.updateSavedRecord();
      }
    },
    updateSavedRecord() {
      const card = store.getters.getActiveCard;

      const activeContent =
        card.localRecords.filter(record => {
          return record.locale === this.getActiveLocale;
        })[0].content || {};

      const clonedContent = JSON.parse(JSON.stringify(activeContent));

      store.commit('setActiveLocalRecordSaved', clonedContent);
    },
    async initializeCard(edited) {
      const card = this.getActiveCard;

      console.log('intializing card', card);
      if (!edited) {
        // initialize default locale once we have the card record, but don't reset default locale if we're already editing
        if (this.getActiveCard.defaultLocale) {
          this.defaultLocale = this.getActiveCard.defaultLocale;
        } else if (
          this.getActiveCard.fallbackLocale &&
          this.getSortedAvailableLocales &&
          this.getSortedAvailableLocales.indexOf(
            this.getActiveCard.fallbackLocale
          ) > -1
        ) {
          this.defaultLocale = this.getActiveCard.fallbackLocale;
        } else if (this.getActiveCard.localRecords) {
          this.defaultLocale = this.getActiveCard.localRecords[0].locale;
        }
        store.commit('setActiveLocale', this.defaultLocale);
      }

      // activeContent could be pulled from a single local Record on mount, or from the locale they just switched to, or be blank if it's a brand new record

      const activeContentObj =
        card.localRecords.length === 1
        ? (card.localRecords[0].draftContent ? { content: card.localRecords[0].draftContent, draft: (JSON.stringify(card.localRecords[0].draftContent) !== JSON.stringify(card.localRecords[0].content)) } : { content: card.localRecords[0].content })
        : (() => {
            const record = card.localRecords.filter(record => {
              return record.locale === this.getActiveLocale;
            })[0];
          return (record.draftContent ? { content: record.draftContent, draft: (JSON.stringify(record.draftContent) !== JSON.stringify(record.content)) } : { content: record.content });
        })();

        if(card.cardType.name === 'opportunity' && (!activeContentObj.content || !activeContentObj.content.actionButton)) {
            if(!activeContentObj.content) {
                activeContentObj.content = {};
            }
            activeContentObj.content.actionButton = {}
        }

        if(card.cardType.name === 'opportunity' && (!activeContentObj.content || !activeContentObj.content.trigger)) {
            console.log('no trigger');
            if(!activeContentObj.content) {
                activeContentObj.content = {};
            }

            activeContentObj.content.trigger = {
                contextType: '',
                imageUrl: ''
            }
        }

      if (activeContentObj.draft) this.isDraft = true;
      const activeContent = activeContentObj.content;

      if (activeContent) {
        store.commit('setActiveLocalRecord', activeContent);
        const clonedContent = JSON.parse(JSON.stringify(activeContent));
        store.commit('setActiveLocalRecordSaved', clonedContent);
      } else {
        store.commit('setActiveLocalRecord', {});
        store.commit('setActiveLocalRecordSaved', {});
      }

      if (card.cardType) {
        this.params = card.cardType.parameters;
        this.fields = card.cardType.fields;
      }

      this.displayName = card.displayName;

      //   console.log('activeContent', activeContent);

      // initialize media
      if (
        (activeContent && activeContent.mediaId) ||
        card.mediaId ||
        card.cardType.name === 'media'
      ) {
        console.log('we have media');

        // prefer the localized record's media
        if (activeContent && activeContent.mediaId) {
          console.log('media here');
          this.getActiveMedia = activeContent.mediaId;
        } else if (this.getActiveLocale === 'EN-US' && card.mediaId) {
          // fallback if media wasn't migrated to a local record and still on the original action card
          this.getActiveMedia = card.mediaId;
        } else {
          this.getActiveMedia = {};
        }
      } else {
        this.getActiveMedia = null;
      }
      this.ready = true;
    },
    saveChanges() {
      this.saveText = 'Saving...';
      let update = this.getActiveLocalRecord;

      if (this.getActiveMedia) {
        update.mediaId = this.getActiveMedia._id;
      }

      postResource(
        '/v1/actioncards/update',
        `id=${this.getActiveCard._id}&locale=${encodeURIComponent(
          this.getActiveLocale
        )}`,
        update
      )
        .then(res => {
          console.log(res);
          return Services.setActiveCard(
            this.$route.params.shortId,
            this.getActiveLocale,
            () => {
              this.initializeCard(true);
            }
          );
        })
        .then(() => {
          this.showSuccessMsg({
            message: `${this.getActiveLocale} Action card saved!`
          });
          const clonedContent = JSON.parse(
            JSON.stringify(this.getActiveLocalRecord)
          );

          store.commit('setActiveLocalRecordSaved', clonedContent);
        })
        .catch(error => {
          this.showErrorMsg({
            message: 'An error occurred. Please try again.'
          });
        });
    },
    checkEdits() {
      console.log('empty check edits');
    }
    // see if we are even using these
    // storeNewHelpInfo() {
    //   const title = this.helpText;
    //   const url = this.helpUrl;
    //   const rowKey = 'ParameterizedHelp';

    //   console.log('submitting new help');

    //   this.checkEdits('helpText', title)
    //     .then(() => {
    //       console.log('updated title');
    //       return this.checkEdits('helpUrl', url);
    //     })
    //     .then(() => {
    //       this.helpText = title;
    //       this.helpUrl = url;
    //       this.showFooterPopup = false;
    //     })
    //     .catch(err => console.log(err));
    // },
    // cleanParams(paramStr) {
    //   const arr = paramStr.match(/{(.*?)}/g) || [];
    //   const sanitized = arr.map(param => param.substring(1, param.length - 1));
    //   return sanitized;
    // },
    // checkEdits(section, string) {
    //     let currentActiveCard = {...this.getActiveCard};
    //     if(section === 'callToAction' || 'title'){
    //       currentActiveCard[section][this.activeSetting] = string;
    //     }
    //     console.log('currentActiveCard', section)
    //     store.commit('setActiveCard', currentActiveCard);
    // }
  },
  async mounted() {
    Services.setActiveCard(
      this.$route.params.shortId,
      this.getActiveLocale,
      this.initializeCard
    );
    Services.getMarkets();
  },
  beforeRouteLeave(to, from, next) {
    if (
      JSON.stringify(this.getActiveLocalRecord) !==
      JSON.stringify(this.getActiveLocalRecordSaved)
    ) {
      const answer = window.confirm(
        'You have unsaved changes. Do you want to leave without saving?'
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  beforeDestroy() {
    Services.clearActiveMedia();
    Services.clearActiveCard();
    Services.clearActiveRecords();
  },
  created() {
    if (
      this.getActiveCard &&
      this.getActiveCard.localRecords &&
      this.getActiveCard.localRecords.length
    ) {
      let activeContentObj =
        this.getActiveCard.localRecords.filter(record => {
          return record.locale === this.getActiveLocale;
        })[0]
      let activeContent = activeContentObj.content || {};
      if (activeContentObj.draftContent) {
        console.log('has draft content');
        activeContent = activeContentObj.draftContent;
      }
      console.log('active content', activeContent);

      store.commit('setActiveLocalRecord', activeContent);
      //   store.commit('setActiveLocalRecordSaved', activeContent);
    }
  }
};
</script>
<style lang="scss" scoped>
div.alerts {
  display: inline-flex;
  flex: 1;
  flex-flow: column nowrap;
  margin: auto 20px auto auto;
  text-align: right;

  span:first-of-type {
    margin-bottom: 5px;
  }
}

.button {
  border-radius: 3px;
  background: #ccc;
  line-height: 1.2rem;
  border: 0;
  transition: all 0.2s;
  opacity: 1;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }

}
.button__submit.active {
  opacity: 1;
  pointer-events: auto;
}

.button__submit.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.togglePopupButton {
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #f5f5f5;
  }

  a {
    color: #337ab7;
    font-size: 0.9rem;
    text-decoration: none;
  }
}
.container {
  background: rgb(238, 238, 238);
  display: flex;
  flex-direction: column;
    min-height: 100%;
  width: 100%;
  align-items: flex-start;
  min-height: calc(100vh - 60px);
}

.card-message {
  h3 {
    // margin-bottom: 2rem;
  }

  label {
    // font-weight: bold;
    font-size: 0.95rem;
    margin-bottom: 0.4rem;
    display: block;
  }
}

.editing__container {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: top;
  padding: 0;
  height: 100%;
}

.card__title-wrapper--wrapper {
  width: 100%;
}

.card__title-wrapper {
  background: #fff;
  padding: 2rem;
  width: 380px;
  min-width: 380px;

  h1 {
    font-size: 1.4rem;
    margin: 0 0 1.4rem;
  }

  p {
    // font-style: italic;
    font-size: 0.9rem;
    margin-top: 5px;
    margin-bottom: 0;

    span {
      text-transform: capitalize;
    }
  }
}

.card-reason,
.card-message,
.card-markets,
.card-languages {
  h3,
  label {
    margin-bottom: 7px;
  }
}
.template__card-wrapper {
  display: flex;
  flex-direction: column;
  padding: 2rem 2rem 2rem 4rem;

  .card-message {
    padding: 0;
  }

  h3 {
    margin-top: 0;
  }
}

.button-group {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0;
  margin-bottom: 1rem;

  button {
    text-transform: capitalize;
  }

  button:first-child {
    margin-left: 0;
  }
}

.options {
  label {
    display: block;
    margin-bottom: 7px;
  }
}

.card__titles span {
  line-height: 1.2rem;
  font-family: 'proxima_nova_ltsemibold';
}

.card__titles h4 {
  color: #aaa;
  font-weight: normal;
  margin: 0 0 5px;
}

.messages {
  width: 100%;
}

.action-card__container {
  display: flex;
  width: 100%;

  @media all and (max-width: 1450px) {
    flex-direction: column;
  }

  .action-card {
    min-width: 510px;
    width: 510px;
  }
  .action-card-english {
    height: 100%;
    margin-top: 2rem;
    display: flex;
    flex-direction: column;

    @media all and (min-width: 1451px) {
      margin-top: -2rem;
      height: 530px;
      padding-left: 2rem;
    }

    .title,
    .description,
    .help {
      font-weight: 300;
      font-family: 'proxima_novalight', Arial, Helvetica, sans-serif;
      font-size: 1.2rem;
    }

    .title {
      min-height: 90px;
      margin-top: 2rem;
    }

    .help {
      margin-top: auto;
    }
  }
}
strong {
    font-weight: bold !important;
}

.locale-picker {
    width: 200px;
}

.copy-button {
    position: absolute;
    right: 1rem;
    top: inherit;
}

.button__delete {
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/CardTemplate.vue